import { ReactComponent as BrandLogo } from "../../assets/logo_TCL_rouge (1).svg";

export const TCL_CS2TIMED_brandVariables = {
  client: "elgiganten-9u2oj", // For picking wich leaderboard to show
  tenantId: "elgiganten-9u2oj", // For picking wich leaderboard to show
  layoutKeyValue: "TCLCS2TIMED",
  brand: "tcl", // For scss
  gameStyle: "cs2timed", // For picking wich leaderboard to show
  eventCode: "tcl_test_march_2024", // Needed for fetching correct challenge
  challengeStatus: "ongoing",
  challengeGameType: "CSGO",
  brandLogo: BrandLogo,
  leaderboardLength: 7,
  prize: {
    nameOf: "win a", // will be marked in color
    typeOfItem: "TCL 25G64 QD-Mini LED monitor", // will be added after nameOf
  },

  content: {
    generalHeadline: "Beat the fastest time!",
    generalHeadlineAlt: "Set the fastest time!",
    subHeadline: "Lorem ipsum...",
    overviewHeadline: "Dreamhack winter 2024 winners overview!",
    endscreenHeadline: "Thank you and congratulations to our",
    raffleText1: "All participants are in a raffle for a",
    raffleText2: "TCL 25G64 QD-Mini LED Monitor",
  },
};
